var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCantBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.705 0 0 6.705 0 15C0 23.295 6.705 30 15 30C23.295 30 30 23.295 30 15C30 6.705 23.295 0 15 0ZM21.7929 19.6779C22.1834 20.0684 22.1834 20.7016 21.7929 21.0921L21.0921 21.7929C20.7016 22.1834 20.0684 22.1834 19.6779 21.7929L15.7071 17.8221C15.3166 17.4316 14.6834 17.4316 14.2929 17.8221L10.3221 21.7929C9.93158 22.1834 9.29842 22.1834 8.90789 21.7929L8.20711 21.0921C7.81658 20.7016 7.81658 20.0684 8.20711 19.6779L12.1779 15.7071C12.5684 15.3166 12.5684 14.6834 12.1779 14.2929L8.20711 10.3221C7.81658 9.93158 7.81658 9.29842 8.20711 8.90789L8.90789 8.20711C9.29842 7.81658 9.93158 7.81658 10.3221 8.20711L14.2929 12.1779C14.6834 12.5684 15.3166 12.5684 15.7071 12.1779L19.6779 8.20711C20.0684 7.81658 20.7016 7.81658 21.0921 8.20711L21.7929 8.90789C22.1834 9.29842 22.1834 9.93158 21.7929 10.3221L17.8221 14.2929C17.4316 14.6834 17.4316 15.3166 17.8221 15.7071L21.7929 19.6779Z",
    fill: "#0088FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCantBox);
export default __webpack_public_path__ + "static/media/cant_box.3f99d5067195a23ebf924604b717771c.svg";
export { ForwardRef as ReactComponent };